import { render } from "./MenuLateral.vue?vue&type=template&id=4958110e&scoped=true"
import script from "./MenuLateral.vue?vue&type=script&lang=js"
export * from "./MenuLateral.vue?vue&type=script&lang=js"

import "./MenuLateral.vue?vue&type=style&index=0&id=4958110e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4958110e"]])

export default __exports__